import React from 'react';
import './servicios-incluidos.css';

const ServiciosIncluidos = (props) => {
  if (!(props.descripcion instanceof Array)) return null;
  if (props.descripcion.length < 0) return null;

  const iconos = props.iconos.reverse();
  const descripciones = props.descripcion.reverse();

  const servicios = descripciones.map((item, index) => (
    // eslint-disable-next-line react/no-array-index-key
    <div key={index} className='item-container'>
      <span className={`color-dinamico icono fa ${iconos[index]}`} />
      <span className='descripcion'>{item.descripciones[0].valor}</span>
    </div>
  ));

  return props.descripcion.length > 0
    ? (
      <div className='services-container'>
        {servicios}
      </div>
    )
    : (null);
};

export default ServiciosIncluidos;
